// 9fbef606107a605d69c0edbcd8029e5d
import CarouselView from '../views';

export default CarouselView;
